import { Component, Input } from '@angular/core';
import { SkillsSubNavigationItem } from '@freelancer/datastore/collections';
import { CalloutPlacement } from '@freelancer/ui/callout';
import { LinkColor, LinkUnderline } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-navigation-secondary-skills-nav-item',
  template: `
    <fl-callout
      [hideArrow]="true"
      [hover]="true"
      [placement]="CalloutPlacement.BOTTOM"
      (calloutOpen)="isActive = true"
      (calloutClose)="isActive = false"
    >
      <fl-callout-trigger class="CalloutTrigger">
        <fl-bit
          class="SkillsNavItem"
          [ngClass]="{
            IsActive: isActive
          }"
        >
          <fl-link
            flTrackingLabel="SkillsNavItemMain"
            [color]="LinkColor.INHERIT"
            [link]="navItem.mainLink.url"
            [underline]="LinkUnderline.NEVER"
          >
            {{ navItem.mainLink.text }}
          </fl-link>
        </fl-bit>
      </fl-callout-trigger>

      <fl-callout-content>
        <fl-bit class="SkillsNavItem-list">
          <app-navigation-secondary-skills-nav-link
            *ngFor="let link of navItem.links; let last = last"
            [skillsNavLink]="link"
            [flMarginBottom]="last ? Margin.NONE : Margin.SMALL"
          ></app-navigation-secondary-skills-nav-link>
        </fl-bit>
      </fl-callout-content>
    </fl-callout>
  `,
  styleUrls: ['./navigation-secondary-skills-nav-item.component.scss'],
})
export class NavigationSecondarySkillsNavItemComponent {
  CalloutPlacement = CalloutPlacement;
  LinkColor = LinkColor;
  LinkUnderline = LinkUnderline;
  Margin = Margin;
  TextSize = TextSize;

  @Input() navItem: SkillsSubNavigationItem;

  isActive: boolean;
}
